'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

var _Applicants = require('../../validators/tugo/Applicants');

var _Applicants2 = _interopRequireDefault(_Applicants);

var _formConfiguration = require('../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _applicant = require('../../transformers/oop/applicant');

var _applicant2 = _interopRequireDefault(_applicant);

var _ActionCreators = require('../../actions/ActionCreators');

var _commonFunctions = require('../../helpers/commonFunctions');

var _step2Functions = require('../../helpers/step2Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fields = [].concat(_toConsumableArray((0, _step2Functions.getBaseFields)()), _toConsumableArray((0, _commonFunctions.getApplicantSportFields)()), _toConsumableArray((0, _commonFunctions.getApplicantMedicalquestions)()), ['applicant[].additional_data.pe_coverage', 'applicant[].additional_data.topup_days', 'applicant[].additional_data.provider']);

var CompleteApplicationComponent = function (_React$Component) {
  _inherits(CompleteApplicationComponent, _React$Component);

  function CompleteApplicationComponent(props) {
    _classCallCheck(this, CompleteApplicationComponent);

    var _this = _possibleConstructorReturn(this, (CompleteApplicationComponent.__proto__ || Object.getPrototypeOf(CompleteApplicationComponent)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.card = null;

    _this.state = {
      setDefaultValues: true,
      formFilled: false,
      limitationsAndExclusions: true,
      openTopUpHint: false
    };
    return _this;
  }

  _createClass(CompleteApplicationComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[1].fields;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.scrollTo(0, 0);
      window.parent.postMessage('scrollToTop', '*');
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(values, dispatch) {
      return (0, _commonFunctions.handleSubmitTugoForm)(values, dispatch, this, _applicant2.default);
    }
  }, {
    key: 'updateProp',
    value: function updateProp(propName, value) {
      this.props.dispatch((0, _reduxForm.change)('genericis', propName, value));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          error = _props.error;


      (0, _step2Functions.populateStep2Fields)(this);

      return _react2.default.createElement(
        _reactBootstrap.Form,
        {
          horizontal: true,
          onSubmit: handleSubmit(this.handleSubmit)
        },
        (0, _step2Functions.getHeaderSection)(this),
        (0, _step2Functions.getPrimaryApplicantSection)(this),
        (0, _step2Functions.getStep2Sections)(this, error)
      );
    }
  }]);

  return CompleteApplicationComponent;
}(_react2.default.Component);

CompleteApplicationComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  forward: _react2.default.PropTypes.func.isRequired,
  back: _react2.default.PropTypes.func.isRequired,
  formConfig: _react2.default.PropTypes.object.isRequired,
  application: _react2.default.PropTypes.object.isRequired,
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object.isRequired,
  savedQuote: _react2.default.PropTypes.object
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    application: state.application,
    formConfig: state.formConfig.config,
    savedQuote: state.savedQuote.data
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    makePayment: function makePayment() {
      return dispatch(makeApplicationPayment.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Applicants2.default
}, mapStateToProps, mapDispatchToProps)(CompleteApplicationComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/tugo/CompleteApplicationContainer.jsx
// module id = 1717
// module chunks = 0